<navigation [isSticky]="false"></navigation>
<div class="container">
  <div class="ip-prefixes__header">
    <h3>
      {{ "Prefixes.header1" | translate }}{{ subscriptionsLength() }}
      {{ "Prefixes.header2" | translate }}
    </h3>
    <div>
      @if (userCanAddPrefixes()) {
        <request-add-prefix />
      }
    </div>
  </div>

  <p>
    {{ "Cert.DDoS.CTA" | translate }}
    <a [routerLink]="'/cert/ddos'">{{ "Global.CTA.Here" | translate }}</a>
  </p>

  <div class="card card--no-padding">
    <div class="table-wrapper">
      <table matSort (matSortChange)="sortData($event)" matSortActive="description" matSortDirection="asc">
        <thead>
          <tr>
            <th class="asc" mat-sort-header="description">
              <div>
                <span>{{ "Prefixes.Table.Description" | translate }}</span>
              </div>
            </th>
            <th class="desc" mat-sort-header="prefix">
              <div>
                <span>{{ "Prefixes.Table.IPPrefix" | translate }}</span>
              </div>
            </th>
            <th mat-sort-header="startdate">
              <div>
                <span>{{ "Prefixes.Table.StartDate" | translate }}</span>
              </div>
            </th>
            <th mat-sort-header="version">
              <div>
                <span>{{ "Prefixes.Table.Version" | translate }}</span>
              </div>
            </th>
            <th mat-sort-header="in_use">
              <div>
                <span>{{ "Prefixes.Table.InUse" | translate }}</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (sub of sortedData(); track sub.subscriptionId) {
            <tr ip-prefix-row [subscription]="sub"></tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="container">
  <footer></footer>
</div>
